import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

const data = [
  { name: 'Ava Smith', attendance: 99 },
  { name: 'Liam Johnson', attendance: 98 },
  { name: 'Olivia Brown', attendance: 97 },
  { name: 'Noah Lee', attendance: 96 },
  { name: 'Emma Davis', attendance: 95 },
];

export default function TopAttendingStudentsChart() {
  return (
    <div className="bg-white rounded-xl shadow p-6 h-[300px] flex flex-col">
      <div className="font-semibold text-lg text-slate-800 mb-2">Top Attending Students</div>
      <div className="flex-1 flex items-end justify-center">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
            barCategoryGap={12}
          >
            <defs>
              <linearGradient id="colorAttendanceBarHorizontal" x1="1" y1="0" x2="0" y2="0">
                <stop offset="0%" stopColor="#2563eb" stopOpacity={0.8}/>
                <stop offset="100%" stopColor="#2563eb" stopOpacity={0.4}/>
              </linearGradient>
            </defs>
            <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis type="number" domain={[90, 100]} hide />
            <YAxis type="category" dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 13 }} width={105} />
            <Tooltip contentStyle={{ borderRadius: 12, border: 'none', boxShadow: '0 2px 8px #0001' }} labelStyle={{ color: '#64748b' }} />
            <Bar dataKey="attendance" fill="url(#colorAttendanceBarHorizontal)" radius={[10, 10, 10, 10]} barSize={20}>
              <LabelList dataKey="attendance" position="right" fill="#2563eb" fontSize={13} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
} 